import { render, staticRenderFns } from "./CourseSelection.vue?vue&type=template&id=42b060f9&scoped=true&"
import script from "./CourseSelection.vue?vue&type=script&lang=ts&"
export * from "./CourseSelection.vue?vue&type=script&lang=ts&"
import style0 from "./CourseSelection.vue?vue&type=style&index=0&id=42b060f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b060f9",
  null
  
)

export default component.exports